<header class="header">
  <div class="header-content">
    <div class="d-block d-md-none">
      <button class="sidebar-toggle-btn mt-0" (click)="toggleSidebar()">
        <span class="hamburger mt-0">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>
    </div>
    <div class="logo">
      <div class="d-none d-md-inline-block">
        <button class="sidebar-toggle-btn" (click)="toggleSidebar()">
          <span class="hamburger">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>
    </div>
    <div class="d-flex justify-content-start align-items-center gap-3">
      <div
        class="user-menu"
        role="button"
        tabindex="0"
        [attr.aria-expanded]="menuOpen"
        aria-haspopup="true"
        aria-label="User menu"
        (click)="toggleMenu()"
        (keydown.enter)="toggleMenu()"
        (keydown.space)="$event.preventDefault(); toggleMenu()"
      >
        <!-- <i class="bi bi-person-circle avatar-icon"></i> -->
        <div class="d-flex justify-content-center align-items-center gap-2">
          <div class="avatar-circle">
            {{ avatarLetter }}
          </div>
          <!-- <div class="avatar-circle">
            S
          </div> -->
          <div class="user-name">{{ user?.first_name }} {{ user?.last_name }}</div>
          <!-- <div class="user-name">Super Admin</div> -->
        </div>

        @if (menuOpen) {
          <div class="dropdown-card">
            <div class="user-info">
              <div class="avatar-circle large">
                {{ avatarLetter }}
              </div>
              <!-- <div class="avatar-circle large">
                S
              </div> -->

              <div class="user-details">
                <div class="user-name">{{ user?.first_name }} {{ user?.last_name }}</div>
                <!-- <div class="user-name">Super Admin</div> -->
                <div class="user-role">
                  {{ user?.role?.name }}
                </div>
                <!-- <div class="user-role">
                  Super Admin
                </div> -->
              </div>
            </div>

            <div class="divider"></div>

            <button type="button" class="logout-btn" (click)="logout($event)">
              <i class="bi bi-box-arrow-right"></i>
              Logout
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</header>
